import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Spin, message } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

const SpcClassIntervalBarGraph = (props) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const chart = useRef(null);

  useEffect(() => {
    let x = am4core.create(
      props.divId ? props.divId : "DivID",
      am4charts.XYChart
    );
    if (props.data) {
      // x.dateFormatter.inputDateFormat = "yyyy-MM-dd";
      x.data = props.data;




  
      //title
      var title = x.titles.create();
      title.text = props.title;
      title.fontSize = 25;
      title.marginBottom = 30;
      title.fontWeight = 600;
      title.fill = "#b1b0b5";

      // Create axes
      var valueAxis = x.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.labels.template.fontSize = 11;
      valueAxis.renderer.labels.template.fill = am4core.color("#7f7f7f");
      valueAxis.renderer.line.strokeOpacity = 0.2;
      valueAxis.renderer.line.strokeWidth = 1;
      valueAxis.renderer.line.stroke = am4core.color("#000");
      

      /* Create axes */

        var categoryAxis = x.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = props.category
          ? props.category
          : "time";
  



      categoryAxis.renderer.minGridDistance = 30;
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.labels.template.fontSize = 11;
      categoryAxis.renderer.labels.template.fill = am4core.color("#7f7f7f");
      categoryAxis.renderer.line.strokeOpacity = 0.2;
      categoryAxis.renderer.line.strokeWidth = 1;
      categoryAxis.renderer.line.stroke = am4core.color("#000");
      categoryAxis.renderer.labels.template.adapter.add(
        "dy",
        function (dy, target) {
          if (target.dataItem && target.dataItem.index & (2 == 2)) {
            return dy + 25;
          }
          return dy;
        }
      );





      /* Create series */
      let columnSeries = x.series.push(new am4charts.ColumnSeries());
      columnSeries.yAxis = valueAxis;
      columnSeries.dataFields.valueY = props.col ? props.col : "col";
      columnSeries.dataFields.categoryX = props.category
        ? props.category
        : "time";
      columnSeries.name = props.col ? props.col : "col";

      columnSeries.columns.template.tooltipText =
        "{categoryX}: [bold]{valueY}[/]";
      columnSeries.columns.template.fillOpacity = 0.8;
      columnSeries.columns.template.strokeOpacity = 0;
      columnSeries.columns.template.fill = "#808283"
      
      // x.colors.list= [
      //   am4core.color("#f8bcd0"),
      //   am4core.color("#f278a1"),
      //   am4core.color("#e91e63"),
      //   am4core.color(props.colorMtd),
      //   am4core.color("#ff5722"),
      //   am4core.color(props.themeColor)
      // ];
      // columnSeries.columns.template.adapter.add("fill", (fill, target) => {
      //   return target.dataItem ? x.colors.getIndex(target.dataItem.index) : fill;
      // });
      columnSeries.columns.template.column.cornerRadiusTopLeft = 10;
      columnSeries.columns.template.column.cornerRadiusTopRight = 10;
      columnSeries.columns.template.column.cornerRadiusBottomLeft = 10;
      columnSeries.columns.template.column.cornerRadiusBottomRight = 10;
      var shadow = columnSeries.filters.push(new am4core.DropShadowFilter());
      shadow.dx = 20;
      shadow.dy = 20;
      shadow.blur = 5;







      let  lineSeries = x.series.push(new am4charts.LineSeries());
      lineSeries.name = "line";
      lineSeries.dataFields.valueY = props.line ? props.line : "line";
      lineSeries.dataFields.categoryX = props.category
      ? props.category
      : "time";
      
      lineSeries.stroke = am4core.color("#fdd400");
      lineSeries.strokeWidth = 3;
      lineSeries.propertyFields.strokeDasharray = "lineDash";
      lineSeries.tooltip.label.textAlign = "middle";
      // lineSeries.smoothing = "monotoneX";
      lineSeries.tensionX = 0.8;
      lineSeries.tensionY = .8;










      chart.current = x;
    }

    return () => {
      x.dispose();
    };
  });

  return (
    <div>
      {props.data ? (
        <div
          id={props.divId ? props.divId : "DivID"}
          style={{
            width: "95%",
            height: "350px",
            padding: "10px",
            marginLeft: "10px",
            marginTop: "10px",
            boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
            borderRadius: "10px",
            backgroundColor:"#000406",
           
          }}
        ></div>
      ) : (
        <div className="Loading">
          <Spin indicator={antIcon} tip="Loading..." />
        </div>
      )}
    </div>
  );
};

export default SpcClassIntervalBarGraph;
